export default values => {
  const errors = {};
  if (!values.label) {
    errors.label = 'Required';
  } else if (values.label?.length > 255) {
    errors.label = 'Max 255 characters';
  } else if (values.label?.length < 2) {
    errors.label = 'Min 2 characters';
  }

  if (!values.projectId) {
    errors.projectId = 'Required';
  }

  return errors;
};
